import traversingService from '../services/traversingService';

/**
 * Button Navigation mit Tabs und Unter-Buttons
 */
class ButtonNavigation {
    /**
     * @param element {Node|Element} Parent-Element
     * @param remoteTargets {NodeList|Array|null} Elemente welche gesteuert werden sollen
     */
    constructor(element, remoteTargets = null) {
        this.parentElement = element;
        this.remoteTargets = remoteTargets;
        this.tabs = this.parentElement.querySelectorAll('.js-button-navigation-tab');
        this.tabButtons = this.parentElement.querySelectorAll('.js-button-navigation-tab-button');

        if (typeof this.parentElement.dataset.activeTargetFieldId !== 'undefined') {
            this.activeTargetField = document.querySelector(`#${this.parentElement.dataset.activeTargetFieldId}`);
        } else {
            this.openTab(this.tabs[0]);
        }

        this.tabButtons.forEach((tabButton) => {
            tabButton.addEventListener('click', this.handleTabAction.bind(this));
        });

        window.addEventListener('orientationchange', () => {
            const activeTab = this.getActiveTab();
            this.openTab(activeTab);
        });
    }

    getActiveTab() {
        return Array.from(this.tabs).find((tab) => tab.classList.contains('active'));
    }

    /**
     * Klick auf Tab-Button
     * @param event {Event} Click-Event
     */
    handleTabAction(event) {
        const tabButton = event.currentTarget;
        const tab = traversingService.getParentByClass(tabButton, 'js-button-navigation-tab');

        if (this.remoteTargets) this.closeAllRemotes();

        this.openTab(tab);
    }

    /**
     * Schließt alle Tabs
     */
    closeAllTabs() {
        this.tabs.forEach(ButtonNavigation.hideElement);
    }

    /**
     * Schließt alle Remote Targets
     */
    closeAllRemotes() {
        this.remoteTargets.forEach(traversingService.hideElement);
    }

    /**
     * Wählt einen Tab aus
     * @param tab {HTMLElement|Node}
     */
    openTab(tab) {
        this.closeAllTabs();

        ButtonNavigation.showElement(tab);

        const {loopIndex} = tab.dataset;

        if (this.activeTargetField) {
            this.activeTargetField.value = loopIndex;
        }

        this.showRemoteTargetsIfExist(Number(loopIndex) || 0);
    }

    /**
     * Macht ein Remote-Target sichtbar
     * @param loopIndex {Number} Index des Tabs in der Loop
     */
    showRemoteTargetsIfExist(loopIndex) {
        const target = this.getTargetByLoopIndex(loopIndex);

        if (target) {
            traversingService.showElement(target);
        }
    }

    /**
     * Sucht nach dem aktuellen Tab in den Remote Targets
     * @param loopIndex {Number} Index des Tabs in der Loop
     * @returns {HTMLElement|Null}
     */
    getTargetByLoopIndex(loopIndex) {
        if (!this.remoteTargets) return null;

        for (let i = 0; i < this.remoteTargets.length; i += 1) {
            const item = this.remoteTargets[i];

            if (Number(item.dataset.loopIndex) === loopIndex) {
                return item;
            }
        }

        return null;
    }

    static hideElement(element) {
        traversingService.hideElement(element);

        const contentWrapper = element.querySelector('.js-button-nav-content-wrapper');
        if (contentWrapper) {
            contentWrapper.style.height = '0';
        }
    }

    static showElement(element) {
        traversingService.showElement(element);

        setTimeout(() => {
            const contentWrapper = element.querySelector('.js-button-nav-content-wrapper');
            if (contentWrapper) {
                const {height} = element.querySelector('.js-button-nav-content')
                    .getBoundingClientRect();
                contentWrapper.style.height = `${height}px`;
            }
        });
    }
}

const buttonNavigation = {
    init() {
        document.querySelectorAll('.js-button-navigation')
            .forEach((element) => {
                const {remoteTargetsClass} = element.dataset;
                let remoteTargets = null;

                if (remoteTargetsClass) {
                    remoteTargets = document.getElementsByClassName(remoteTargetsClass);
                }

                // eslint-disable-next-line no-new
                new ButtonNavigation(element, remoteTargets);
            });
    },
};

export default buttonNavigation;
